
import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "vue";
import LeftMenu from "@/components/LeftMenu.vue";
import AppInfoBar from "@/components/AppInfoBar.vue";
import { onBeforeRouteUpdate, useRouter } from "vue-router";
import { useApplicationInfo } from "@/hooks/frontApp";
import { useStore } from "vuex";
import { IGlobalState } from "@/store";

export default defineComponent({
  components: {
    LeftMenu,
    AppInfoBar,
  },
  setup() {
    const router = useRouter();
    const store = useStore<IGlobalState>();
    const state = reactive({
      menuList: [
        {
          id: "1",
          title: "应用概况",
          path: "/appinfo",
        },
        {
          id: "2",
          title: "授权管理",
          path: "/authschool",
        },
        {
          id: "3",
          title: "API管理",
          path: "/interfacemanage",
        },
        {
          id: "4",
          title: "数据互操作管理",
          path: "/changedatamanage",
        },
      ],
      appId: router.currentRoute.value.query.appid,
    });

    const application = computed(() => store.state.frontApp.application);
    /**
     * 根据appId 获取应用详情
     */
    const getApplicationInfo = async () => {
      await useApplicationInfo(store, state.appId);
    };
    /**
     * 页面一开始加载就调用获取应用详情
     */
    onMounted(async () => {
      await getApplicationInfo();
    });
    const leftMenuRef = ref<any>(null);
    onBeforeRouteUpdate((to) => {
      if (to.path === "/manageappindex") {
        // leftMenuRef.value.clickMenuItem({
        //   id: state.menuList[0].id,
        //   name: state.menuList[0].title,
        //   path: state.menuList[0].path,
        // });
        router.push('/personalhome');
      }
    });
    return {
      ...toRefs(state),
      application,
    };
  },
});
